module.exports = __webpack_public_path__ + "static/media/carshowz_icon.4b8d5adc.jpg";